import { CardActionsClassKey } from '@material-ui/core/CardActions';

const MuiCardActions = (): Partial<Record<CardActionsClassKey, unknown>> => ({
    root: {
        padding: 16,
        justifyContent: 'flex-end',
    },
    spacing: {
        '& > :not(:first-child)': {
            marginLeft: 16,
        },
    },
});

export default MuiCardActions;
